import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  Input,
  notification,
  Typography,
  Form
} from 'antd';
import {
  LockOutlined,
  PhoneOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { httpService } from '../../services/httpService';
import { useTheme } from '../../theme/ThemeProvider';
import './styles.css';

const { Text } = Typography;

const Auth: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { theme } = useTheme();

  // Check if user is already authenticated on component mount
  useEffect(() => {
    if (httpService.isAuthenticated()) {
      navigate('/home', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (values: { phoneNumber: string }) => {
    const { phoneNumber } = values;

    if (!phoneNumber || phoneNumber.length < 10) {
      notification.error({ message: 'لطفا شماره تلفن معتبر را وارد کنید' });
      return;
    }

    setIsLoading(true);
    try {
      const response = await httpService.sendOTP({ 
        mobileNumber: phoneNumber, 
        remember: false, 
        isOTP: true 
      });
      
      console.log('📱 SendOTP Response:', response);
      
      // Check if user exists based on the response
      if (response.data?.isUserExist === false) {
        // User doesn't exist, redirect to registration page
        notification.info({ message: 'کاربر جدید شناسایی شد. لطفا اطلاعات خود را تکمیل کنید.' });
        navigate('/user-registration', { state: { phoneNumber } });
      } else {
        // User exists, proceed to OTP verification
        notification.success({ message: 'کد تایید ارسال شد' });
        navigate('/verify-otp', { state: { phoneNumber } });
      }
    } catch (error) {
      notification.error({ message: 'خطا در ارسال کد تایید' });
      console.error('Send OTP error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container" style={{ background: theme.background }}>
      <div className="auth-content">
        <Card className="card-themed">
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <img 
              src="/shahsalogo.webp"
              alt="SHAHSA Logo" 
              style={{ 
                width: '300px', 
                height: 'auto', 
                marginBottom: '12px',
                borderRadius: '8px'
              }} 
            />
          </div>
          <Text type="secondary" style={{ fontSize: 16, color: theme.text.secondary }}>
            لطفا شماره تلفن خود را وارد کنید
          </Text>
          <Form 
            form={form}
            layout="vertical" 
            onFinish={handleSubmit}
            size="large"
          >
            <Form.Item 
              label="شماره تلفن"
              name="phoneNumber"
              rules={[
                { required: true, message: 'لطفا شماره تلفن را وارد کنید' },
                { min: 10, message: 'شماره تلفن باید حداقل ۱۰ رقم باشد' },
                { max: 11, message: 'شماره تلفن نمی‌تواند بیشتر از ۱۱ رقم باشد' }
              ]}
            >
              <Input
                placeholder="مثال: ۰۹۱۲۳۴۵۶۷۸۹"
                prefix={<PhoneOutlined style={{ color: theme.primary }} />}
                maxLength={11}
                style={{ 
                  direction: 'ltr', 
                  textAlign: 'left',
                  backgroundColor: theme.input.background,
                  borderColor: theme.input.border,
                  color: theme.text.primary
                }}
                className="input-themed"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                size="large"
                block
                loading={isLoading}
                htmlType="submit"
                icon={<LockOutlined />}
                style={{ 
                  backgroundColor: theme.button.primary, 
                  borderColor: theme.button.primary,
                  color: theme.button.text
                }}
                className="btn-primary"
              >
                ارسال کد تایید
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Auth; 